module.exports = __webpack_public_path__ + "img/home_four_001.154d28ee.png";